export default __webpack_public_path__ + "static/media/share.ba857ca8.svg";